import { Helmet } from 'react-helmet';
import seoMetaData from '../../../Include/Seo/seoMetaData';
import Navbar from '../../../Include/Navbar/Navbar';
import Footer from '../../../Include/Footer/Footer';
import Breadcrumb from '../MobileApp/Breadcum';
import breadcrumbData from '../Data/breadcrumbData';
import whyusData from '../Data/whyusData';
import aboutData from '../Data/aboutData';
import contactData from '../Data/contactData';
import faqData from '../Data/faqData';
import '../../../../assets/css/services.css'; // Importing the CSS file for this component
import About from '../MobileApp/About';
import Whyus from '../MobileApp/Whyus';
import Contact from '../MobileApp/Contact';
import Faq from '../MobileApp/Faq';
import Contactus from '../../Home/Contact';

export default function Index() {
 const { title, description } = seoMetaData.ai;
  return (
    <>
     <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href="https://www.cloudkode.com/services/ai-development" />
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "FAQPage",
              "mainEntity": [{
                "@type": "Question",
                "name": "What AI technologies do you specialize in?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "We specialize in machine learning, natural language processing, and computer vision."
                }
              },{
                "@type": "Question",
                "name": "Can you integrate AI into existing applications?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Yes, we can enhance your existing applications with AI capabilities."
                }
              },{
                "@type": "Question",
                "name": "How do you ensure data privacy in AI projects?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "We follow strict data governance policies and use secure methods to handle sensitive data."
                }
              },{
                "@type": "Question",
                "name": "Do you provide AI consulting services?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Yes, we offer consulting to help businesses identify AI opportunities and develop strategies."
                }
              }]
            }
          `}  
        </script>
      </Helmet>
   <Navbar />
   <Breadcrumb data={breadcrumbData.ai} /> 
   <About data={aboutData.ai} />
   <Whyus data={whyusData.ai}/>
   <Contact data={contactData.ai}/>
   <Faq data={faqData.ai}/>
   <Contactus/>
   <Footer/>
   </>
  )
}
